import { useContentConfig } from './useContentConfig';

/**
 * Hook to check if a specific feature flag is enabled
 * @param flagPath - Dot-notation path to the flag (e.g., 'showTimestamps' or 'bannerInfoButton.enabled')
 * @returns boolean indicating if the feature is enabled
 */
export const useFeatureFlag = (flagPath: string): boolean => {
  const { data: config } = useContentConfig();
  const featureFlags = config?.featureFlags;

  if (!featureFlags) {
    return false;
  }

  // Navigate through the object using dot notation
  const keys = flagPath.split('.');
  let current: unknown = featureFlags;

  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return false;
    }
  }

  return Boolean(current);
};
